export default __webpack_public_path__ + "static/media/medal.c393ab6c.png";